import { BaseNode } from '@playbooks/action-cards-utils/src'

const hideFromWebPlayVisibilityRule = {
  check: (node: BaseNode) => !(node as { hideFromWebPlay?: boolean }).hideFromWebPlay,
}

export default function* getNodesVisibilityRules() {
  yield hideFromWebPlayVisibilityRule
}
